<nav class="menu-nav navbar navbar-expand-lg navbar-light d-flex justify-content-between align-items-center">
  <div class="d-flex align-items-center">
    @if (isLoggedIn) {
      <lib-menu-nav-notification />
    }

    <lib-language-switcher />
  </div>
</nav>
